<div class="container-fluid">
    <div class="row">
        <div class="col-lg-12">
            <div class="card card-custom gutter-b card-stretch">
                <div class="card-body">
                    <div class="project_view custom_instance_view">
                        <div class="row position-relative">
                            <div class="btn-header butoons w-100 justify-content-end d-flex">
                                <button
                                    type="button"
                                    class="btn primary-ebtn me-3"
                                    (click)="backClick()"
                                    *ngIf="selectedTabLabel != 'Details'"
                                    [disabled]="isDisableBack"
                                >
                                    <div class="d-flex align-items-center gap-1">
                                        <span class="svg-icon-primary svg-icon-2x">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="18px" height="18px" viewBox="0 0 24 24" version="1.1">
                                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                    <polygon points="0 0 24 0 24 24 0 24" />
                                                    <!-- Arrow tail (horizontal line) -->
                                                    <rect
                                                        fill="#000000"
                                                        opacity="0.3"
                                                        transform="translate(15.000000, 12.000000) rotate(90.000000) translate(-15.000000, -12.000000)"
                                                        x="11"
                                                        y="4.5"
                                                        width="2"
                                                        height="9"
                                                        rx="1"
                                                    />
                                                    <!-- Arrow head (left chevron) -->
                                                    <path
                                                        d="M14.2929,15.7071 C13.9024,16.0976 13.2692,16.0976 12.8787,15.7071 
                                                                                               L6.87868,9.70711 C6.48816,9.31658 6.48816,8.68342 6.87868,8.29289 
                                                                                               L12.8787,2.29289 C13.2692,1.90237 13.9024,1.90237 14.2929,2.29289 
                                                                                               C14.6834,2.68342 14.6834,3.31658 14.2929,3.70711 
                                                                                               L9.58579,8.41421 L14.2929,13.1213 
                                                                                               C14.6834,13.5118 14.6834,14.145 14.2929,14.5355 Z"
                                                        fill="#000000"
                                                        fill-rule="nonzero"
                                                    />
                                                </g>
                                            </svg>
                                        </span>

                                        Back
                                    </div>
                                </button>
                                <button href="javascript:void()" type="button" class="btn secondary-ebtn me-3" [routerLink]="['/home']">Cancel</button>
                                <button type="button" class="btn primary-ebtn" (click)="nextButtonClick()" [disabled]="selectedTab == 0 && !isOrgFormValid">
                                    <div class="d-flex align-items-center gap-1">
                                        {{ selectedTabLabel == 'Instances' ? 'Save' : 'Next' }}
                                        <span *ngIf="selectedTabLabel != 'Instances'" class="svg-icon-primary svg-icon-2x"
                                            ><svg
                                                class="d-flex"
                                                xmlns="http://www.w3.org/2000/svg"
                                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                                width="18px"
                                                height="18px"
                                                viewBox="0 0 24 24"
                                                version="1.1"
                                            >
                                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                    <polygon points="0 0 24 0 24 24 0 24" />
                                                    <rect
                                                        fill="#000000"
                                                        opacity="0.3"
                                                        transform="translate(8.500000, 12.000000) rotate(-90.000000) translate(-8.500000, -12.000000) "
                                                        x="7.5"
                                                        y="7.5"
                                                        width="2"
                                                        height="9"
                                                        rx="1"
                                                    />
                                                    <path
                                                        d="M9.70710318,15.7071045 C9.31657888,16.0976288 8.68341391,16.0976288 8.29288961,15.7071045 C7.90236532,15.3165802 7.90236532,14.6834152 8.29288961,14.2928909 L14.2928896,8.29289093 C14.6714686,7.914312 15.281055,7.90106637 15.675721,8.26284357 L21.675721,13.7628436 C22.08284,14.136036 22.1103429,14.7686034 21.7371505,15.1757223 C21.3639581,15.5828413 20.7313908,15.6103443 20.3242718,15.2371519 L15.0300721,10.3841355 L9.70710318,15.7071045 Z"
                                                        fill="#000000"
                                                        fill-rule="nonzero"
                                                        transform="translate(14.999999, 11.999997) scale(1, -1) rotate(90.000000) translate(-14.999999, -11.999997) "
                                                    />
                                                </g>
                                            </svg>
                                        </span>
                                    </div>
                                </button>
                            </div>
                            <div class="col-md-12">
                                <mat-tab-group
                                    class="tab-wrapper"
                                    #tabGroup
                                    [(selectedIndex)]="selectedTab"
                                    (selectedTabChange)="tabChangeFromTabs($event)"
                                    dynamicHeight
                                >
                                    <mat-tab label="Details" [disabled]="isDisableOrgTab">
                                        <app-organization-wizard-details
                                            (OrgData)="OrgData = $event"
                                            (formStatusChange)="onFormStatusChange($event)"
                                            *ngIf="isEditMode != null"
                                            [OrganizationId]="OrganizationId"
                                            [isEditMode]="isEditMode"
                                        ></app-organization-wizard-details>
                                        <!-- <app-organization-wizard-details
                                            (OrgData)="OrgData = $event"
                                            (formStatusChange)="onFormStatusChange($event)"
                                            *ngIf="isCreateMode == true"
                                        ></app-organization-wizard-details> -->
                                    </mat-tab>
                                    <mat-tab label="AzureAD Details" [disabled]="isDisableAzureDetailTab" *ngIf="isFederatedOrganization">
                                        <div class="wrapper-azureDetails">
                                            <app-azure-ad-details [OrgData]="OrgData"></app-azure-ad-details>
                                        </div>
                                    </mat-tab>

                                    <mat-tab label="Roles & Permission" [disabled]="isDisableUserTypeTab" *ngIf="isViewEnabled === true">
                                        <div class="wrapper-userType">
                                            <app-user-type (securityRolesData)="securityRolesData = $event"></app-user-type>
                                        </div>
                                    </mat-tab>
                                    <mat-tab label="Users" [disabled]="isDisableUsersTab">
                                        <ng-template mat-tab-label>
                                            <span class="sg-mat-txt" aria-label="">Users </span>
                                        </ng-template>
                                        <app-organization-users [securityRolesData]="securityRolesData"></app-organization-users>
                                    </mat-tab>
                                    <mat-tab label="Instances" [disabled]="isDisableInstanceTab">
                                        <app-organization-instances></app-organization-instances>
                                    </mat-tab>
                                </mat-tab-group>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
